import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const ImageContainer = styled.div`
	height: 196px;
	width: 100%;
	border-radius: 8px;
	overflow: hidden;
	position: relative;
`;

export const Image = styled.img`
	height: 100%;
	width: 100%;
	transition: all 0.3s ease-out 0s;
	object-fit: cover;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 8px;
	top:8px;
	position: relative;
`;

export const Name = styled.div`
	${({ theme }) => theme.typography.headlines.h5}
	color: ${({ theme }) => theme.colors.neutral.black};
`;

export const Info = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-template-rows: repeat(2, 1fr);
	gap: 8px;
	white-space: nowrap;
`;

export const Dealer = styled.div`
	height: 35px;
	align-self: center;
	margin-top: 12px;

	img {
		height: 100%;
		width: auto;
	}
`;

export const Location = styled.div`
	align-self: center;
`;

export const Separator = styled.hr`
	height: 1px;
	padding: 0;
	margin: 12px 0;
	border: none;
	width: 100%;
	background-color: #ced4da;
`;

export const Container = styled(Link)`
	width: 100%;
	display: flex;
	flex-direction: column;
	${({ theme }) => theme.boxShadow.primary}
	background-color: ${({ theme }) => theme.colors.neutral.white};
	cursor: pointer;
	padding: 12px;
	border-radius: 8px;
	transition: all ease-in-out 0.5s;

	&:hover {
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);

		${Image} {
			scale: 1.2;
		}
	}
`;

export const Offers = styled.div`
	align-self: center;
	${({ theme }) => theme.typography.headlines.h6};
	color: ${({ theme }) => theme.colors.neutral.black};
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 0 12px;
	width: 100%;

	div {
		display: flex;
		justify-content: space-between;
	}
`;

export const Status = styled.div`
	align-self: center;
	margin-top: 12px;
`;

export const ButtonWrapper = styled.div`
	width: 100%;
	align-self: center;
	display: flex;
	justify-content: center;
`;
